import { DEFAULT_FOLDER_ID, FOLDER_TRASH_ID } from "@zapier/utils";
import { trpc } from "../trpc";

interface Input {
  folderId?: string;
}

/** Mutation hook that bulk-trashes mixed asset ids and invalidates caches. */
export function useBulkTrashAssets({ folderId }: Input) {
  const utils = trpc.useUtils();

  return trpc.asset.bulkTrash.useMutation({
    onSettled: () => {
      utils.table.search.invalidate();
      utils.canvas.search.invalidate();
      utils.zap.searchZaps.invalidate();
      utils.zap.storageZaps.invalidate();
      utils.zap.organizationZaps.invalidate();

      utils.asset.getHydratedFolderAssets.invalidate();

      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({
          folderId,
        });
      }

      utils.asset.getHydratedFolderAssets.invalidate({
        folderId: FOLDER_TRASH_ID,
      });

      utils.asset.getHydratedFolderAssets.invalidate({
        folderId: DEFAULT_FOLDER_ID,
      });

      utils.userProperty.getHydratedFavoriteAssets.invalidate();
    },
  });
}
